module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEXSURBVEhL3dS9SgNBFIbhxUK0Mdh6CxaBKAgiYpVS8Arivdj401sIAQVzA+m9B1OFgEoggYA2AUULQX0/MwNTjDNz0sUPHjgzs+csuyxb/fts4Qo9TB3V2tPZ3FlGB98Zt9C15lxAA15xigZqjuoz6EzXnMOcF6h5D0fQa/l0ez770Pr5d2WMGuUEX8FafPwNwr3ihAPlBhtYxzb0it7gz80Jh5cwJzYkRVnF5qzMJzYk5RBD3KMosSGl6sgm1lhijANkE2vOaWMNRYkNSLmEKb7xPahTVmCKbxwEdYo5vvE6qFPM8Y3NoE4x5wFqXMKTq//yCHN2MJqVVQuxwTLBLuaK/i2KnuIOH9AftI8ujlH83S9qquoHnczSWtMudFoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-wood/dark/24.png
// module id = 2572
// module chunks = 2